import Image from "next/image";
import { Header } from "../header";
import { cn } from "@workspace/ui/lib/utils";
import { Button } from "@workspace/ui/components/button";

export function TryingDurationExplainer3({
  title,
  image,
  values,
  handleNext,
}: {
  title: string;
  image: string;
  values: { description: string; image: string; color: string }[];
  handleNext: () => void;
}) {
  return (
    <>
      <div className="flex flex-col flex-1 gap-[22px] overflow-y-auto min-h-0 pb-12">
        <Header title={title} />
        <div className="flex flex-col gap-4">
          <div className="relative w-full h-[300px] md:h-[440px]">
            <Image
              src={image}
              alt="trying-duration"
              fill
              className="object-contain self-start"
            />
          </div>
          <div className="flex flex-col gap-4">
            {values.map((value, index) => (
              <div
                key={value.description}
                className={cn(
                  "flex gap-4  pb-4 items-center",
                  index < values.length - 1 &&
                    "border-b border-b-[rgba(0, 0, 0, 0.05)]"
                )}
              >
                <div>
                  <div
                    className={cn(
                      "relative flex items-center gap-2 h-10 w-10 justify-center rounded-[6px]"
                    )}
                    style={{ backgroundColor: value.color }}
                  >
                    <Image
                      src={value.image}
                      alt={value.description}
                      height={20}
                      width={20}
                    />
                  </div>
                </div>
                <p className="text-primary title-14"
                id={`question-option-${index}`}
                data-testid={`question-option-${index}`}
                >
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="sticky bottom-0 flex flex-col gap-3 pb-6">
        <Button onClick={handleNext} variant="default" className="w-full shrink-0">Next</Button>
      </div>
    </>
  );
}
